import { IconOpenInNewMS } from '@/constants/icons';
import { Box, LinearProgress, Typography } from '@mui/material';
import { useHref } from 'react-router-dom';

import {
  CompletionData,
  SectionStatus,
} from '../../../api/characteristics/types';
import {
  ButtonBox,
  OutlinedButton,
  StyledPaper,
  SummaryMobileStepper,
} from '../styles';
import { SectionStatusBadge } from './StatusIndicators';

interface CharacteristicsSectionSummaryProps {
  completionData: CompletionData | undefined;
  loadingCompletion: boolean;
  isLegacyCharacteristicsData: boolean;
}

export function CharacteristicsSectionSummary({
  completionData,
  loadingCompletion,
  isLegacyCharacteristicsData,
}: CharacteristicsSectionSummaryProps): JSX.Element {
  const href = useHref('characteristics');

  const totalSections = completionData?.total_sections ?? 0;
  const completeSections = completionData?.completed_sections ?? 0;
  const percentage = completionData?.percentage ?? 0;
  const getStatus = (): SectionStatus => {
    if (completionData?.is_complete) return 'complete';
    if (completeSections > 0) return 'partial';
    return 'pending';
  };
  const status = getStatus();

  if (loadingCompletion) return <LinearProgress sx={{ mx: 1 }} />;

  return (
    <StyledPaper>
      {isLegacyCharacteristicsData ? (
        <Typography color="error">
          A seção de características desta OS está desatualizada.
        </Typography>
      ) : (
        <>
          <Box sx={{ width: '100%', mb: 1 }}>
            <SummaryMobileStepper
              variant="progress"
              steps={101}
              position="static"
              activeStep={percentage}
              nextButton={<Box />}
              backButton={<Box />}
            />
            <Box display="flex" justifyContent="space-between" my={2} mx={1}>
              <Box display="flex">
                <Typography fontSize="14px" color="#707070">
                  {completeSections} de {totalSections} seções completas
                </Typography>
                <Typography mx={1}>&middot;</Typography>
                <Typography color="primary.main" fontSize="14px">
                  {completionData?.filled_required_fields ?? 0}/
                  {completionData?.total_required_fields ?? 0} campos
                  obrigatórios
                </Typography>
              </Box>
              <Typography fontSize="14px" fontWeight={600} color="primary">
                {percentage}%
              </Typography>
            </Box>
          </Box>
          <ButtonBox>
            <OutlinedButton onClick={() => window.open(href, '_blank')}>
              ver respostas
              {IconOpenInNewMS}
            </OutlinedButton>
            <SectionStatusBadge status={status} />
          </ButtonBox>
        </>
      )}
    </StyledPaper>
  );
}
